import { useTheme, type Lang } from '@kss/theme';

/**
 * Lightweight i18n for the customer app — enough to demonstrate the
 * EN / हिंदी / ಕನ್ನಡ switcher wired to the theme slice. Extend the
 * dictionaries per screen; missing keys fall back to English then to
 * the key itself.
 */
type Dict = Record<string, string>;

const en: Dict = {
  bestSellers: 'Best sellers',
  all: 'All',
  veg: 'Veg',
  nonVeg: 'Non-veg',
  bestseller: 'Bestseller',
  offers: 'Offers',
  addToCart: 'ADD',
  yourOrder: 'Your order',
  placeOrder: 'Place order',
  toPay: 'To pay',
  callWaiter: 'Call waiter',
  viewBill: 'View bill',
  orderStatus: 'Order status',
  searchPlaceholder: 'Search dishes…'
};

const hi: Dict = {
  bestSellers: 'बेस्ट सेलर',
  all: 'सभी',
  veg: 'शाकाहारी',
  nonVeg: 'मांसाहारी',
  bestseller: 'लोकप्रिय',
  offers: 'ऑफ़र',
  addToCart: 'जोड़ें',
  yourOrder: 'आपका ऑर्डर',
  placeOrder: 'ऑर्डर करें',
  toPay: 'देय राशि',
  callWaiter: 'वेटर बुलाएँ',
  viewBill: 'बिल देखें',
  orderStatus: 'ऑर्डर स्थिति',
  searchPlaceholder: 'व्यंजन खोजें…'
};

const kn: Dict = {
  bestSellers: 'ಅತ್ಯುತ್ತಮ ಮಾರಾಟ',
  all: 'ಎಲ್ಲಾ',
  veg: 'ಸಸ್ಯಾಹಾರಿ',
  nonVeg: 'ಮಾಂಸಾಹಾರಿ',
  bestseller: 'ಜನಪ್ರಿಯ',
  offers: 'ಆಫರ್‌ಗಳು',
  addToCart: 'ಸೇರಿಸಿ',
  yourOrder: 'ನಿಮ್ಮ ಆರ್ಡರ್',
  placeOrder: 'ಆರ್ಡರ್ ಮಾಡಿ',
  toPay: 'ಪಾವತಿಸಬೇಕಾದ',
  callWaiter: 'ವೇಟರ್ ಕರೆಯಿರಿ',
  viewBill: 'ಬಿಲ್ ನೋಡಿ',
  orderStatus: 'ಆರ್ಡರ್ ಸ್ಥಿತಿ',
  searchPlaceholder: 'ಭಕ್ಷ್ಯಗಳನ್ನು ಹುಡುಕಿ…'
};

const dicts: Record<Lang, Dict> = { en, hi, kn };

export function useT() {
  const { lang } = useTheme();
  return (key: keyof typeof en): string => dicts[lang]?.[key] ?? en[key] ?? key;
}
